import type { User } from "../user";
import { SkedPlanCodeName, UpsellFeatureType } from "./types";
import {
  UPGRADE_APPROVAL_VIEWED,
  UPGRADE_COMPARISON_VIEWED,
  UPGRADE_COMPETITOR_VIEWED,
  UPGRADE_EXCEL_REPORTS_VIEWED,
  UPGRADE_FRONTIFY_VIEWED,
  UPGRADE_LABELS_PLANNING_VIEWED,
  UPGRADE_LABELS_REPORTING,
  UPGRADE_LIBRARY_VIEWED,
  UPGRADE_PAID_INSIGHTS_VIEWED,
  UPGRADE_PDF_REPORT_VIEWED,
  UPGRADE_REPORT_BUILDER_VIEWED,
  UPGRADE_TEAMWORK_VIEWED,
  UPGRADE_USERS_VIEWED,
} from "../../constants/Events";

export const isUserPlan = (
  user: User | undefined,
  ...plans: SkedPlanCodeName[]
) => {
  return plans.some((plan) => user?.plan?.includes(plan));
};

type PlanVersionUser = { pricingVersion?: string } | undefined;

export const isLegacyPlan = (user: PlanVersionUser) => {
  return !user?.pricingVersion?.includes("2024");
};

export const getTrackingEventByFeature = (feature: UpsellFeatureType) => {
  switch (feature) {
    case "approvals": {
      return UPGRADE_APPROVAL_VIEWED;
    }
    case "internal-approvals":
    case "external-approvals": {
      return UPGRADE_APPROVAL_VIEWED;
    }
    case "labels-planning": {
      return UPGRADE_LABELS_PLANNING_VIEWED;
    }
    case "standard-pdf": {
      return UPGRADE_PDF_REPORT_VIEWED;
    }
    case "competitor-analytics": {
      return UPGRADE_COMPETITOR_VIEWED;
    }
    case "paid-ads": {
      return UPGRADE_PAID_INSIGHTS_VIEWED;
    }
    case "excel": {
      return UPGRADE_EXCEL_REPORTS_VIEWED;
    }
    case "comparison-period": {
      return UPGRADE_COMPARISON_VIEWED;
    }
    case "labels-reporting": {
      return UPGRADE_LABELS_REPORTING;
    }
    case "teamwork": {
      return UPGRADE_TEAMWORK_VIEWED;
    }
    case "user-generated-content": {
      return UPGRADE_LIBRARY_VIEWED;
    }
    case "add-account-user": {
      return UPGRADE_USERS_VIEWED;
    }
    case "frontify-media": {
      return UPGRADE_FRONTIFY_VIEWED;
    }
    case "report-builder-enterprise":
    case "report-builder-professional": {
      return UPGRADE_REPORT_BUILDER_VIEWED;
    }
  }
  return "feature-upsell-viewed";
};
